import type { TDescription } from "@/models/common.model"
import type { Medal } from "@/models/medals.model"

export type MedalCount = {
  gold: number
  silver: number
  bronze: number
}

export type MedalsDTO = {
  name: string
  venue: string
  medals: MedalCount
  rsc_code: string
  count_for_table: boolean
}

export type ParticipantMedals = {
  name: string
  venue: string
  medals: MedalCount
  rscCode: string
  countForTable: boolean
}

// Props interfaces para los componentes
export type MedalsParticipantsProps = {
  participants: ParticipantMedals[]
  isLoading: boolean
  onFilterChange: (filterType: string, value: string) => void
}

export type ParticipantCardProps = {} & ParticipantMedals

export function mapMedalsResponseToParticipant(dto: MedalsDTO): ParticipantMedals {
  return {
    name: dto.name,
    venue: dto.venue,
    medals: {
      gold: dto.medals.gold,
      silver: dto.medals.silver,
      bronze: dto.medals.bronze,
    },
    rscCode: dto.rsc_code,
    countForTable: dto.count_for_table,
  }
}

export function mapMedalsResponseToParticipants(dtos: MedalsDTO[]): ParticipantMedals[] {
  return dtos.map(mapMedalsResponseToParticipant)
}

type ApiMedal = {
  id?: number
  code: string
  description: TDescription
  order: number
}

export class MedalsMapper {
  static toDto(data: ApiMedal[]): Medal[] {
    if (!data)
      return []

    return data.map(medal => ({
      id: medal.id || 0,
      code: medal.code,
      description: medal.description,
      order: medal.order,
      idiomaticDescription: medal.description,
    }))
  }

  static toEntity(dto: Medal): Medal {
    return dto
  }
}
